var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z",
    stroke: "url(#paint0_linear_13_10438)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5684 5.42813C14.9993 5.31124 15.4437 5.25136 15.8902 5.25C17.1832 5.25 18.4231 5.76361 19.3374 6.67785C20.2516 7.59209 20.7652 8.83207 20.7652 10.125C20.7652 11.4179 20.2516 12.6579 19.3374 13.5721C18.4231 14.4864 17.1832 15 15.8902 15",
    stroke: "url(#paint1_linear_13_10438)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18.5062C2.2612 17.423 3.27191 16.5389 4.44676 15.9286C5.6216 15.3183 6.92608 14.9996 8.25 14.9996C9.57392 14.9996 10.8784 15.3183 12.0532 15.9286C13.2281 16.5389 14.2388 17.423 15 18.5062",
    stroke: "url(#paint2_linear_13_10438)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8906 15C17.2147 14.9992 18.5194 15.3174 19.6944 15.9277C20.8693 16.5381 21.8799 17.4225 22.6406 18.5063",
    stroke: "url(#paint3_linear_13_10438)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_10438",
    x1: -7.76786,
    y1: 10.125,
    x2: 10.3393,
    y2: 10.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_10438",
    x1: 7.48622,
    y1: 10.125,
    x2: 18.9947,
    y2: 10.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_10438",
    x1: -13.9286,
    y1: 16.7529,
    x2: 11.1429,
    y2: 16.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_10438",
    x1: 8.17634,
    y1: 16.7531,
    x2: 20.7121,
    y2: 16.7531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01439B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1650FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.504adcd690fdfcecf8eecb1e851107a9.svg";
export { ForwardRef as ReactComponent };